import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { INNER_BOTTOM_SPACE_DESK, colorsPalette, MIDDLE_MARGIN, LARGE_MARGIN } from '../../theme';

const useStyles = (background, displayType) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: displayType !== 'WithDescription' ? 0 : MIDDLE_MARGIN,
        background: theme.palette.secondary.dark,
        '&:first-child': {
          marginTop: 76,
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: displayType !== 'WithDescription' ? MIDDLE_MARGIN : LARGE_MARGIN,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
          '&:first-child': {
            marginTop: 120,
          },
        },
        [theme.breakpoints.up('md')]: {
          paddingBottom: LARGE_MARGIN,
        },
      },
      container: {
        paddingRight: displayType === 'Slider' ? 0 : 16,
        '& .swiper-container::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          right: -1,
          width: 50,
          height: 74,
          background: `transparent linear-gradient(-90deg, ${theme.palette.secondary.dark} 0%, #2D323800 100%) 0% 0% no-repeat padding-box`,
          zIndex: 3,
        },

        [theme.breakpoints.up('sm')]: {
          paddingRight: 16,

          '& .swiper-container::after': {
            // Hide for now shadow on desktop
            opacity: 0,
            background: `transparent linear-gradient(-90deg, ${
              background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light
            } 0%, #2D323800 100%) 0% 0% no-repeat padding-box`,
          },
        },

        [theme.breakpoints.up('lg')]: {
          '& .swiper-wrapper': {
            justifyContent: 'center',
          },
        },
      },
      cardsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'center',
        marginRight: `-${MIDDLE_MARGIN}px`,
        '& $card': {
          width: `calc(50% - ${MIDDLE_MARGIN}px)`,
          maxWidth: 'unset',
          boxShadow: 'none',
          background: 'transparent',
          marginBottom: MIDDLE_MARGIN,
          marginRight: MIDDLE_MARGIN,
          height: 'unset',
          '& img': {
            maxHeight: 95,
          },
        },
        [theme.breakpoints.up('sm')]: {
          justifyContent: 'center',
          '& $card': {
            width: `calc(100%/3 - ${MIDDLE_MARGIN}px)`,
          },
        },
        [theme.breakpoints.up('md')]: {
          alignItems: 'center',
          flexWrap: 'nowrap',
          justifyContent: 'space-between',
          marginRight: 0,

          '&, & > h2': {
            marginRight: 20,
          },
          '& div:last-child': {
            marginRight: 0,
          },
          '& $card': {
            marginBottom: 0,
            marginRight: 20,
            width: 'unset',
            maxWidth: 140,
          },
        },
      },
      card: {
        width: 135,
        height: 74,
        padding: 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 13,
        marginBottom: 13,
        boxShadow: `0px 3px 6px ${colorsPalette.black}`,
        background: colorsPalette.blueDark,
        boxSizing: 'border-box',
        '& img': {
          maxWidth: '100%',
          maxHeight: '28px',
        },
        [theme.breakpoints.up('sm')]: {
          fleShrink: 1,
          width: 'auto',
          maxWidth: 140,
          height: 'auto',
          padding: 0,
          boxShadow: 'none',
          background: 'transparent',
          marginBottom: 0,
          marginRight: 0,
          '& img': {
            height: 'auto',
            objectFit: 'contain',
            maxHeight: 98,
            width: '100%',
          },
        },
      },
      cardSlider: {
        maxHeight: 'none',
        [theme.breakpoints.up('sm')]: {
          width: 194,
          maxWidth: 'none',
          height: 106,
          justifyContent: 'center',
          padding: 15,
          maxHeight: 'none',
        },
      },
      heading: {
        marginBottom: MIDDLE_MARGIN,
        display: displayType === 'WithDescription' ? 'none' : 'block',
        [theme.breakpoints.up('sm')]: {
          marginBottom: INNER_BOTTOM_SPACE_DESK,
          display: 'block',
        },
        [theme.breakpoints.up('md')]: {
          display: displayType === 'Block' ? 'none' : 'block',
        },
      },
      headingBlock: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
          display: 'block',
          flexShrink: 0,
        },
      },
      partnersDescWrapper: {
        display: 'flex',
        flexDirection: 'column',

        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row',
        },
      },
      headingDesc: {
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
      cardsDescWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',

        [theme.breakpoints.up('sm')]: {
          width: '80%',
          margin: 'auto',
        },
      },
      cardDesc: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: theme.palette.secondary.light,
        boxShadow: `0px 3px 6px ${colorsPalette.black}`,
        borderRadius: 5,
        marginBottom: 18,
        padding: 0,

        [theme.breakpoints.up('sm')]: {
          flexDirection: 'row',
          marginBottom: 23,
          padding: '0 40px 0 0',
        },
      },
      descImgWrap: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 16,
        padding: 22,

        '& img': {
          height: 100,
          maxWidth: '100%',
          objectFit: 'contain',
        },

        [theme.breakpoints.up('sm')]: {
          flexShrink: 0,
          width: '28%',
          marginBottom: 0,
          padding: '35px 35px 40px 35px',

          '& img': {
            width: '100%',
          },
        },
      },
      partnerDesc: {
        fontSize: 18,
        lineHeight: '23px',
        color: colorsPalette.gray,
        textAlign: 'center',
        padding: '0 22px 22px',

        [theme.breakpoints.up('sm')]: {
          textAlign: 'left',
          paddingTop: 35,
          paddingBottom: 40,
          paddingLeft: 25,
        },
      },
      partnerDescBlockDesc: {
        marginTop: 20,
        fontSize: 22,
        lineHeight: '28px',
        color: colorsPalette.grayLight,
      },
      whiteBg: {
        background: colorsPalette.white,
      },
    }),
  );
export default useStyles;
